<template>
  <div
    class="modal fade"
    id="interviewProgressModal"
    tabindex="-1"
    data-backdrop="static"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <span>面談紀錄歷程</span>
        </div>
        <div class="modal-body">
          <div class="evaluation-person-info">
            <div>
              <label for="">姓名</label>
              <div>{{ recordList.Interviewee }}</div>
            </div>

            <div>
              <label for="">面談日期</label>
              <div
                v-for="(date, index) in recordList.InterviewDateList"
                :key="index"
              >
                {{ $common.dateTimeFormatter(date) }}
              </div>
            </div>
            <div v-for="score in recordList.Scores" :key="score.Seq">
              <label for="">{{ score.Name }}</label>
              <div>{{ score.OriginScore }}/{{ score.Score }}</div>
            </div>

            <span
              style="
                position: absolute;
                right: 5px;
                bottom: 2px;
                color: #ffffff;
                z-index: 2;
                font-size: 0.9em;
              "
            >
              最後更新者：{{ recordList.UpdateUser }}
            </span>
          </div>
          <template
            v-if="
              recordList.InterviewRecords &&
              recordList.InterviewRecords.length > 0
            "
          >
            <div style="display: flex; margin-top: 2px">
              <div class="evaluation-body fixed">
                <div
                  class="evaluation-name"
                  style="height: 60px; line-height: 50px"
                >
                  單位面試主管
                </div>
                <div
                  v-for="(item, index) in recordList.InterviewRecords[0]
                    .InterviewRecordAppraisals"
                  :key="index"
                  class="evaluation-field"
                >
                  {{ item.Name }}
                </div>

                <template v-if="recordList.ResumeType === 'IDL'">
                  <div class="evaluation-field">職等</div>
                </template>

                <div
                  class="evaluation-field"
                  style="height: 150px; overflow-y: auto"
                >
                  面談說明
                </div>

                <div
                  class="evaluation-field"
                  style="height: 150px; overflow-y: auto"
                >
                  個人備註
                </div>
                <div
                  class="evaluation-field"
                  style="
                    border-bottom: 0.1px solid;
                    border-bottom-color: #dfdfdf;
                  "
                >
                  面談結果
                </div>
              </div>

              <div style="flex: 1; min-width: 1px">
                <carousel
                  :key="Math.random()"
                  :items="recordList.InterviewRecords.length"
                  :nav="true"
                  :dots="false"
                >
                  <div
                    v-for="record in recordList.InterviewRecords"
                    class="evaluation-body"
                    :key="record.InterviewSupervisorId"
                    @dblclick="$common.copyText($event)"
                  >
                    <div class="evaluation-name" style="height: 60px">
                      【{{ record.InterviewTitle }}】<br />
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="
                          record.InterviewSupervisor +
                          ' (' +
                          record.InterviewUserType +
                          ')'
                        "
                        placement="right"
                      >
                        <span>
                          {{ record.InterviewSupervisor }} ({{
                            record.InterviewUserType
                          }})
                        </span>
                      </el-tooltip>
                    </div>

                    <div
                      v-for="(item, index) in record.InterviewRecordAppraisals"
                      class="evaluation-field"
                      :key="index"
                    >
                      <template
                        v-if="item.Result !== '-' && item.Result !== '未填寫'"
                      >
                        <el-tooltip
                          v-if="item.Remark"
                          class="item"
                          effect="dark"
                          :content="item.Remark"
                          placement="right"
                        >
                          <span>
                            {{ item.Result }}
                          </span>
                        </el-tooltip>
                        <span v-else>{{ item.Result }}</span>
                      </template>
                      <span v-else>{{ item.Result }}</span>
                    </div>

                    <template v-if="recordList.ResumeType === 'IDL'">
                      <!-- 職等 -->
                      <div class="evaluation-field">
                        {{ record.ExpectedJobLevel }}
                      </div>
                    </template>

                    <!-- 面談說明 -->
                    <div
                      class="evaluation-field"
                      style="height: 150px; overflow-y: auto"
                    >
                      <div>
                        {{ record.Remark }}
                      </div>
                    </div>
                    <!-- 個人備註 -->
                    <div
                      class="evaluation-field"
                      style="height: 150px; overflow-y: auto"
                    >
                      <div>
                        {{ record.PersonalRemark }}
                      </div>
                    </div>
                    <!-- 面談結果 -->
                    <div
                      class="evaluation-field"
                      style="
                        border-bottom: 0.1px solid;
                        border-bottom-color: #dfdfdf;
                      "
                    >
                      <div>
                        {{ record.InterviewResult }}
                      </div>
                    </div>
                  </div>
                </carousel>
              </div>
            </div>
          </template>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            關閉
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import carousel from "vue-owl-carousel2";

export default {
  props: ["MatchId"],
  name: "InterviewProgress",

  components: {
    carousel,
  },

  data() {
    return {
      showModal: false,
      recordList: [],
    };
  },

  methods: {
    getInterviewRecordHistory() {
      this.updateLoading(true);

      this.$api.approveInterview
        .getInterviewRecordForHr(this.MatchId)
        .then((response) => {
          if (response.status === 200) {
            console.log("xxx", response.data);
            this.recordList = response.data;
          }
          this.updateLoading(false);
          $("#interviewProgressModal").modal("show");
        });
    },

    // loading
    ...mapActions(["updateLoading"]),
  },
};
</script>
